// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'
import Text from './Text'
import Caption from './Caption'
import color from 'michelangelo/dist/Components/styles/color'

type BodyTitleProps = {
    title: string,
    usePadding: boolean
}
const TitleContainer: ReactComponentStyled<{}> = styled.div`
  justify-self: center;
  background-color: ${color.white};
  max-width: 100%;
  @media only screen and (max-width: 445px) {
    padding-top: 8px;
  }
`
TitleContainer.displayName = 'TitleContainer'
class BodyTitle extends Component<BodyTitleProps, {}> {
  render () {
    const { title, usePadding } = this.props
    return (
      <Caption usePadding={usePadding}>
        <TitleContainer>
          <Text text={title} size='1' align='left' fontColor='default' />
        </TitleContainer>
      </Caption>
    )
  }
}

export default BodyTitle
